import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {NamedTemplateDirective} from 'src/app/directives/named-template.directive';
import {TargetBlankDirective} from './target-blank.directive';
import {CircularProgressBarGradientDirective} from './circular-progress-bar-gradient.directive';
import {NumericDirective} from 'src/app/directives/numeric.directive';
import {MultiSelectDirective} from './multi-select.directive';
import {TrimDirective} from 'src/app/directives/trim.directive';
import {PaginatorDirective} from 'src/app/directives/paginator.directive';
import { TableDirective } from './table/table.directive';
import { TableHeadDirective } from './table/table-head.directive';
import { TableRowDirective } from './table/table-row.directive';
import { TableRowContentDirective } from './table/table-row-content.directive';
import { TableCellDirective } from './table/table-cell.directive';


@NgModule({
  declarations: [
    TargetBlankDirective,
    NamedTemplateDirective,
    CircularProgressBarGradientDirective,
    NumericDirective,
    MultiSelectDirective,
    TrimDirective,
    PaginatorDirective,
    TableDirective,
    TableHeadDirective,
    TableRowDirective,
    TableRowContentDirective,
    TableCellDirective,
  ],
  exports: [
    TargetBlankDirective,
    NamedTemplateDirective,
    CircularProgressBarGradientDirective,
    NumericDirective,
    MultiSelectDirective,
    TrimDirective,
    PaginatorDirective,
    TableDirective,
    TableHeadDirective,
    TableRowDirective,
    TableRowContentDirective,
    TableCellDirective,
  ],
  imports: [
    CommonModule
  ]
})
export class DirectivesModule {
}
